import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { API_V3_URL } from 'src/app/config/config';
import { LanguageService } from '../../language/language.service';
import { ApiCallBase } from '../apiCallBase';
import { catchError, map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class QuizzesResultsByQuizzesService extends ApiCallBase {
  correctedLanguage = 'EN-US';
  constructor(
    public languageService: LanguageService,
    public http: HttpClient,
    public router: Router,
  ) {
    super(languageService, http, router);
    this.correctedLanguage = this.language === 'es' ? 'ES-LA' : 'EN-US';
  }

  getQuizzesWithExecutions(body: any) {
    body.user_id = this.userId;
    body.language = this.correctedLanguage;
    const url = `${API_V3_URL}/quiz-metrics/quizzes-with-executions`;
    return this.http
      .post(url, this.convertCamelToSnakeCase(body), this.getHttpOptionsV3())
      .pipe(
        catchError((error: HttpErrorResponse) => {
          console.error('Error retrieving quizzes with executions:', error);
          throw error;
        }),
      );
  }

  getMetricsForQuizzes(body: any) {
    body.user_id = this.userId;
    body.language = this.correctedLanguage;
    const url = `${API_V3_URL}/quiz-metrics/aggregated-metrics-for-quiz`;
    return this.http
      .post(url, this.convertCamelToSnakeCase(body), this.getHttpOptionsV3())
      .pipe(
        map((response: any) => {
          return this.convertKeysToCamelCase(response);
        }),
        catchError((error: HttpErrorResponse) => {
          console.error('Error retrieving the quizzes metrics:', error);
          throw error;
        }),
      );
  }

  getMetricsForQuizzesEvaluation(body: any) {
    body.user_id = this.userId;
    body.language = this.correctedLanguage;
    const url = `${API_V3_URL}/quiz-metrics/aggregated-metrics-for-assessment-quiz`;
    return this.http
      .post(url, this.convertCamelToSnakeCase(body), this.getHttpOptionsV3())
      .pipe(
        map((response: any) => {
          return this.convertKeysToCamelCase(response);
        }),
        catchError((error: HttpErrorResponse) => {
          console.error('Error retrieving the metrics:', error);
          throw error;
        }),
      );
  }

  getQuestions(quizId: string) {
    const url = `${API_V3_URL}/quiz/${quizId}/question?user_id=${this.userId}&language=${this.correctedLanguage}`;
    return this.http.get(url, this.getHttpOptionsV3()).pipe(
      map((response: any) => {
        return this.convertKeysToCamelCase(response);
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('Error retrieving the questions:', error);
        throw error;
      }),
    );
  }

  aggregatedMetricsforQuestion(body: any) {
    body.user_id = this.userId;
    body.language = this.correctedLanguage;
    const url = `${API_V3_URL}/quiz-metrics/aggregated-metrics-for-question`;
    return this.http
      .post(url, this.convertCamelToSnakeCase(body), this.getHttpOptionsV3())
      .pipe(
        catchError((error: HttpErrorResponse) => {
          console.error('Error retrieving the metrics:', error);
          throw error;
        }),
      );
  }
}
